import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';
import { CodeTextQueryModel } from '../../code-text/model/code-text-query-model';

@JsonObject('KovanHrPerIdentificationSubtypeQueryModel')
export class PerIdentificationSubtypeQueryModel extends CodeTextQueryModel {
    @EmptyControl()
    @JsonProperty('hrmTypeId', Number, true)
    hrmTypeId: number = null;

    @EmptyControl()
    @JsonProperty('uuidList', [String], true)
    uuidList: Array<string> = null;

    @EmptyControl()
    @JsonProperty('idList', [Number], true)
    idList: Array<number> = null;
}
